import { io } from "socket.io-client";
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { showToast } from '../redux/common/commonActions';
import { newNotifications, onlineUsersList } from '../redux/user/userActions';
import { onlineUsersListSocket } from '../redux/socket/socketActions';
import useActiveUser from "../hooks/useActiveUser";
import { SOCKET_BASE } from "../api_endpoints/API_URL";

const useSocket = () => {
    const dispatch = useDispatch()
    const activeUser = useActiveUser();

    const {
        isLoggedIn,
        sendNotification,
        userID,
        userRole,
        prevLoggedOutId
    } = useSelector((state) => state.userState);
    const activeRole = activeUser ?? userRole
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        const newSocket = io(SOCKET_BASE);
        let cleanupFunction = () => { };

        if (isLoggedIn) {
            setSocket(newSocket);
            newSocket.emit("addNewUser", userID);

            const handleConnectError = () => {
                //Connection error
                // setTimeout(() => {
                    newSocket.connect();
                // }, 100);
            };

            const handleGetOnlineUsers = (res) => {
                dispatch(onlineUsersList(res))
                dispatch(onlineUsersListSocket(res))
            };

            const handleNewNotification = (res) => {
                dispatch(showToast({ show: true, msg: res.notification_title }));
                dispatch(newNotifications(res));
            };

            // Event listeners
            newSocket.on("connect_error", handleConnectError);
            newSocket.on("getOnlineUsers", handleGetOnlineUsers);
            newSocket.on("newNotification", handleNewNotification);

            cleanupFunction = () => {
                // Cleanup function
                newSocket.off("connect_error", handleConnectError);
                newSocket.off("getOnlineUsers", handleGetOnlineUsers);
                newSocket.off("newNotification", handleNewNotification);
                newSocket.disconnect();
            };
        } else {
            newSocket.emit("onLogout", prevLoggedOutId, (response) => {
                newSocket.disconnect();
                localStorage.clear()
            });
        }

        return cleanupFunction;
    }, [isLoggedIn, userID, activeRole, prevLoggedOutId]);


    useEffect(() => {
        if (socket === null) return;
        if (sendNotification !== "" && userRole !== "SuperAdmin" && userRole !== "Admin") {
            socket.emit("sendNotification", sendNotification);
        }
    }, [sendNotification]);
};

export default useSocket;
